import { render, staticRenderFns } from "./auth0.vue?vue&type=template&id=34a15139"
import script from "./auth0.vue?vue&type=script&lang=js"
export * from "./auth0.vue?vue&type=script&lang=js"
import style0 from "./auth0.vue?vue&type=style&index=0&id=34a15139&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports